import LeaderBoardPage from "./LeaderBoardPage";

export default LeaderBoardPage